'use client';

import Image from 'next/image';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@/shadcn/ui/dialog';

interface RichTextImageProps {
  src: string;
  width: number;
  height: number;
  alt?: string;
}

export default function RichTextImage({
  src,
  width,
  height,
  alt,
}: RichTextImageProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="block w-full p-0 m-0 border-0 bg-transparent cursor-zoom-in"
          aria-label={
            alt ? `Open "${alt}" in full size` : 'Open image in full size'
          }
        >
          <Image
            className="rounded-[1.25rem] w-full h-auto"
            src={{ src, width, height }}
            alt={alt ?? ''}
          />
        </button>
      </DialogTrigger>
      <DialogContent className="!w-[min(120rem,calc(100%-4rem))] !max-h-[90vh] !bg-transparent !border-0 !shadow-none !p-0">
        <VisuallyHidden>
          <DialogTitle>{alt || 'Image'}</DialogTitle>
        </VisuallyHidden>
        <Image
          className="rounded-[1.25rem] w-full h-auto max-h-[90vh] object-contain"
          src={{ src, width, height }}
          alt={alt ?? ''}
          quality={100}
        />
      </DialogContent>
    </Dialog>
  );
}
